import { render, staticRenderFns } from "./pending-prescription-status-chip.vue?vue&type=template&id=50c204e4&scoped=true&lang=pug&"
import script from "./pending-prescription-status-chip.vue?vue&type=script&lang=ts&"
export * from "./pending-prescription-status-chip.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50c204e4",
  null
  
)

export default component.exports